import { getProductAvailability } from "../hooks/useWorkingTime";

/**
 * Confere os itens do último pedido contra o cardápio de agora e devolve só
 * os que podem voltar para a sacola, com as respostas já ligadas às perguntas
 * atuais (o preço sai delas, então nada do pedido antigo é reaproveitado).
 *
 * Um item fica de fora se o produto sumiu, está desativado ou fora do horário,
 * se alguma opção escolhida não existe mais ou foi desativada, ou se uma
 * pergunta obrigatória deixou de estar respondida.
 */
export default function buildReorderEntries(
  items,
  products,
  questionsByProduct,
  now = new Date(),
) {
  const entries = [];
  let skipped = 0;

  (items || []).forEach((item) => {
    const product = products.find((p) => p.id === item.productId);
    if (
      !product ||
      product.disabled ||
      !getProductAvailability(product, now).isAvailable
    ) {
      skipped++;
      return;
    }

    const questions = questionsByProduct[product.id] || [];
    const answers = item.answers.map((a) => {
      const question = questions.find((q) => q.id === a.questionId);
      const option =
        question && question.options.find((o) => o.id === a.optionId);
      if (!question || !option || option.disabled) return null;
      return {
        questionId: a.questionId,
        optionId: a.optionId,
        qtt: a.qtt,
        question,
      };
    });

    const allRequiredAnswered = questions.every((q) => {
      if (!(q.minQtt > 0)) return true;
      const answered = answers
        .filter((a) => a && a.questionId === q.id)
        .reduce((sum, a) => sum + a.qtt, 0);
      return answered >= q.minQtt;
    });

    if (answers.some((a) => a === null) || !allRequiredAnswered) {
      skipped++;
      return;
    }

    entries.push({
      productId: product.id,
      qtt: item.qtt,
      observations: item.observations || "",
      answers,
    });
  });

  return { entries, skipped };
}
